import { simpleGqlClient } from '@/graphql/simple-client.jsx';

async function gql(query, variables = {}) {
  const response = await simpleGqlClient.query(query, variables);
  if (response.errors?.length) {
    throw new Error(response.errors[0].message || 'Error GraphQL');
  }
  return response.data;
}

export function recepcionesBySucursal(variables) {
  return gql(
    `query($sucursalId: ID!, $fechaDesde: DateTime, $fechaHasta: DateTime, $estado: String) {
      recepcionesBySucursal(sucursalId: $sucursalId, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, estado: $estado) {
        id sucursalId tipo fojaId estado modo observaciones fechaRecepcion
      }
    }`,
    variables
  ).then(r => r.recepcionesBySucursal || []);
}

export function crearRecepcion(input) {
  return gql(
    `mutation($input: CrearRecepcionInput!) {
      crearRecepcion(input: $input) { id sucursalId tipo fojaId estado modo fechaRecepcion }
    }`,
    { input }
  ).then(r => r.crearRecepcion);
}

export function guiasPendientesDeRecepcion(variables) {
  return gql(
    `query($sucursalId: ID!, $lineaId: ID, $fojaId: ID, $desde: DateTime, $hasta: DateTime) {
      guiasPendientesDeRecepcion(sucursalId: $sucursalId, lineaId: $lineaId, fojaId: $fojaId, desde: $desde, hasta: $hasta) {
        id numero origenSucursalId destinoSucursalId lineaId fojaId estadoLogistico conIncidencia recibidaAt
      }
    }`,
    variables
  ).then(r => r.guiasPendientesDeRecepcion || []);
}

export function marcarGuiaRecibida(recepcionId, guiaId) {
  return gql(
    `mutation($recepcionId: ID!, $guiaId: ID!) {
      marcarGuiaRecibida(recepcionId: $recepcionId, guiaId: $guiaId) { id guiaId estado }
    }`,
    { recepcionId, guiaId }
  );
}

export function marcarGuiaConIncidencia(input) {
  return gql(
    `mutation($recepcionId: ID!, $guiaId: ID!, $incidenciaTipo: String!, $incidenciaDetalle: String, $fotosJson: String) {
      marcarGuiaConIncidencia(recepcionId: $recepcionId, guiaId: $guiaId, incidenciaTipo: $incidenciaTipo, incidenciaDetalle: $incidenciaDetalle, fotosJson: $fotosJson) { id guiaId estado }
    }`,
    input
  );
}

export function marcarGuiaFaltante(recepcionId, guiaId, detalle) {
  return gql(
    `mutation($recepcionId: ID!, $guiaId: ID!, $detalle: String) {
      marcarGuiaFaltante(recepcionId: $recepcionId, guiaId: $guiaId, detalle: $detalle) { id guiaId estado }
    }`,
    { recepcionId, guiaId, detalle }
  );
}

export function recibirTodoPorFoja(recepcionId) {
  return gql(
    `mutation($recepcionId: ID!) {
      recibirTodoPorFoja(recepcionId: $recepcionId) { id guiaId estado }
    }`,
    { recepcionId }
  );
}

export function cerrarRecepcion(recepcionId) {
  return gql(
    `mutation($input: CerrarRecepcionInput!) {
      cerrarRecepcion(input: $input) { id estado }
    }`,
    { input: { recepcionId } }
  ).then(r => r.cerrarRecepcion);
}

export function monitorRecepcion(sucursalId) {
  return gql(
    `query($sucursalId: ID!) {
      monitorRecepcion(sucursalId: $sucursalId) { pendientes recibidasHoy conIncidenciaHoy }
    }`,
    { sucursalId }
  ).then(r => r.monitorRecepcion);
}

export function getConfig(sucursalId, key) {
  return gql(
    `query($sucursalId: ID!, $key: String!) {
      getConfig(sucursalId: $sucursalId, key: $key) { sucursalId key value }
    }`,
    { sucursalId, key }
  ).then(r => r.getConfig);
}

export function recibirGuiaEnDestino(input) {
  return gql(
    `mutation($input: RecibirGuiaDestinoInput!) {
      recibirGuiaEnDestino(input: $input) {
        id numero origenSucursalId destinoSucursalId lineaId estadoLogistico recibidaAt conIncidencia
      }
    }`,
    { input }
  ).then(r => r.recibirGuiaEnDestino);
}

export function recibirFojaCompletaV2(input) {
  return gql(
    `mutation($input: RecibirFojaCompletaInput!) {
      recibirFojaCompleta(input: $input) {
        total ok error errores { guiaId message }
      }
    }`,
    { input }
  ).then(r => r.recibirFojaCompleta);
}

export function validarRecepcionQr(codigoQr) {
  return gql(
    `query($codigoQr: String!) {
      validarRecepcionQr(codigoQr: $codigoQr) {
        valid guiaId format checksumValid message
      }
    }`,
    { codigoQr }
  ).then(r => r.validarRecepcionQr);
}

export function recepcionQrScan(input) {
  return gql(
    `mutation($input: RecepcionQrScanInput!) {
      recepcionQrScan(input: $input) {
        id numero origenSucursalId destinoSucursalId lineaId estadoLogistico recibidaAt conIncidencia
      }
    }`,
    { input }
  ).then(r => r.recepcionQrScan);
}
